<div class="main-item-container" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex fxLayout="row" fxLayoutAlign=" center" class="details" fxLayoutGap="10px">
    <lineup-avatar matCardAvatar [image]="item.personImage" [thumbnail]="true"></lineup-avatar>
    <div fxLayout="column" (click)="onItemClicked(item)" class="clickable-area">
      <a class="person-name" [matTooltip]="item.personName">{{ item.personName }}</a>
      <span class="position-status"
        ><a class="team-name" [matTooltip]="item.teamName">{{ item.teamName }}</a>
      </span>
    </div>
  </div>

  <p fxFlex="none" class="status">{{ item.seatUpdatedOn | dateDifference }}</p>
</div>
